// @flow

/**
 * Module dependencies.
 */

import { setStyledProps } from 'client/styles';
import React from 'react';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  children?: any,
  component?: React$Element<*>,
  [key: string]: any
};

/**
 * Layout wrapper.
 */

const LayoutWrapper = styled.div`${(props: Object): any => setStyledProps(props)}`;

/**
 * Export `Layout` component.
 */

export default function Layout(props: Props): React$Element<*> {
  return (
    <LayoutWrapper {...props}>
      {props.children}
    </LayoutWrapper>
  );
}



// WEBPACK FOOTER //
// ../src/client/components/core/layout/index.js